import {
  computed,
  readonly,
  ref,
  useContext
} from "@nuxtjs/composition-api";
import { Logger, useConfigStore } from "@wemade-vsf/core";
function useConfig() {
  const { app } = useContext();
  const loading = ref(false);
  const error = ref({ load: null });
  const configStore = useConfigStore();
  const config = computed(() => configStore.storeConfig);
  const load = async (params) => {
    var _a;
    error.value.load = null;
    loading.value = true;
    Logger.debug("useConfig/load");
    try {
      const { data } = await app.$vsf.$magento.api.storeConfig((_a = params == null ? void 0 : params.customQuery) != null ? _a : null, params == null ? void 0 : params.customHeaders);
      configStore.$patch((state) => {
        state.storeConfig = data.storeConfig || {};
      });
    } catch (err) {
      Logger.debug("[ERROR] useConfig/load", err);
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };
  return {
    config,
    loading: readonly(loading),
    load
  };
}
export * from "./useConfig";
var useConfig_default = useConfig;
export {
  useConfig_default as default,
  useConfig
};
